import '.cy{display:inline-flex;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.s{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { LinkAnchor } from '../link/LinkAnchor'

export type BreadcrumbLevel = {
  label: string
  to?: string
}

export type BreadcrumbsProps = {
  levels: BreadcrumbLevel[]
}

export const Breadcrumbs = ({ levels }: BreadcrumbsProps) => {
  return (
    <div className="cy r s"
    >
      {levels?.map((level, index) => (
        <Crumb
          text={level.label}
          isLast={levels?.length === index + 1}
          to={level.to}
          key={index}
        />
      ))}
    </div>
  )
}

const Crumb = ({
  text,
  isLast,
  to,
}: {
  text: string
  isLast: boolean
  to?: string
}) => {
  return (
    <LinkAnchor
      to={to ?? '#'}
      style={{
        fontFamily: 'FunnelDisplay',
        fontWeight: isLast ? 600 : 400,
        color: isLast ? 'var(--brand-secondary)' : 'var(--palette-blue-300)',
        cursor: isLast ? 'default' : 'pointer',
      }}
    >
      {isLast ? text : `${text} /`}
    </LinkAnchor>
  )
}
